/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CompanyAccessModule'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/CompanyAccessModule'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CompanyAccessModuleApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CompanyAccessModule);
  }
}(this, function(ApiClient, CompanyAccessModule) {
  'use strict';

  /**
   * CompanyAccessModule service.
   * @module api/CompanyAccessModuleApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new CompanyAccessModuleApi. 
   * @alias module:api/CompanyAccessModuleApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the companyAccessModuleDisableAccessModuleOfTypeGet operation.
     * @callback module:api/CompanyAccessModuleApi~companyAccessModuleDisableAccessModuleOfTypeGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * disableAccessModuleOfType
     * @param {String} _4SAPIAppID 
     * @param {Integer} moduleID 
     * @param {module:api/CompanyAccessModuleApi~companyAccessModuleDisableAccessModuleOfTypeGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.companyAccessModuleDisableAccessModuleOfTypeGet = function(_4SAPIAppID, moduleID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companyAccessModuleDisableAccessModuleOfTypeGet";
      }

      // verify the required parameter 'moduleID' is set
      if (moduleID == undefined || moduleID == null) {
        throw "Missing the required parameter 'moduleID' when calling companyAccessModuleDisableAccessModuleOfTypeGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'moduleID': moduleID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CompanyAccessModule/disableAccessModuleOfType', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companyAccessModuleEnableAccessModuleGet operation.
     * @callback module:api/CompanyAccessModuleApi~companyAccessModuleEnableAccessModuleGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * enableAccessModule
     * @param {String} _4SAPIAppID 
     * @param {Integer} accessModuleID 
     * @param {module:api/CompanyAccessModuleApi~companyAccessModuleEnableAccessModuleGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.companyAccessModuleEnableAccessModuleGet = function(_4SAPIAppID, accessModuleID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companyAccessModuleEnableAccessModuleGet";
      }

      // verify the required parameter 'accessModuleID' is set
      if (accessModuleID == undefined || accessModuleID == null) {
        throw "Missing the required parameter 'accessModuleID' when calling companyAccessModuleEnableAccessModuleGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'accessModuleID': accessModuleID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/CompanyAccessModule/enableAccessModule', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companyAccessModuleLoadCurrentCompanyAccessGet operation.
     * @callback module:api/CompanyAccessModuleApi~companyAccessModuleLoadCurrentCompanyAccessGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CompanyAccessModule>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadCurrentCompanyAccess
     * @param {String} _4SAPIAppID 
     * @param {module:api/CompanyAccessModuleApi~companyAccessModuleLoadCurrentCompanyAccessGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CompanyAccessModule>}
     */
    this.companyAccessModuleLoadCurrentCompanyAccessGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companyAccessModuleLoadCurrentCompanyAccessGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [CompanyAccessModule];

      return this.apiClient.callApi(
        '/CompanyAccessModule/loadCurrentCompanyAccess', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
